/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Grid, Typography, Button } from '@mui/material';
import './CardfordownloadEditViewAction/CardfordownloadEditViewAction.css';
import { fonts, themes } from '../themes/themes';
import { useAppSelector } from '../../infra/hooks';
import { check_user_permission } from '../configs/utils';

interface contentTileType {
  tile_value: string;
  subtitle1: string;
  assetId: any;
  subtitle2: string;
  assetType: string;
  subtitle3: string;
  assignedDate: any;
  trans: any;
  onClick?: () => void;
}

const ActiveAssetListBox: React.FC<contentTileType> = ({
  tile_value,
  subtitle1,
  assetId,
  subtitle2,
  assetType,
  subtitle3,
  assignedDate,
  trans,
  onClick,
}) => {
  const auth_permissions = useAppSelector(
    (state: any) => state.authPermissionSlice?.authPermission,
  );

  return (
    <Grid container className="action-tileContainer">
      <Grid item style={{ flexGrow: 1 }}>
        <Typography className="title1" sx={{ fontSize: '1em' }}>
          {tile_value}
        </Typography>
        <Grid container>
          <Grid item>
            <Typography className="subtitle1" sx={{ fontSize: '0.75em' }}>
              {subtitle1} :
            </Typography>
          </Grid>
          <Grid item>
            <Typography
              className="identifierNo"
              sx={{
                fontSize: '0.75em',
              }}
            >
              {assetId}
            </Typography>
          </Grid>
        </Grid>
        <Grid container>
          <Grid item>
            <Typography className="subtitle1" sx={{ fontSize: '0.75em' }}>
              {subtitle2} :
            </Typography>
          </Grid>
          <Grid item>
            <Typography
              className="identifierNo"
              sx={{
                fontSize: '0.75em',
              }}
            >
              {assetType}
            </Typography>
          </Grid>
        </Grid>
        <Grid container>
          <Grid item>
            <Typography className="subtitle1" sx={{ fontSize: '0.75em' }}>
              {subtitle3} :
            </Typography>
          </Grid>
          <Grid item>
            <Typography
              className="identifierNo"
              sx={{
                fontSize: '0.75em',
              }}
            >
              {assignedDate}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      {check_user_permission(auth_permissions, true, 'edit') ? (
        <Grid item style={{ marginTop: '1.3em' }}>
          <Button
            onClick={onClick}
            style={{
              fontFamily: fonts.fontFamily,
              fontSize: fonts.subtitle,
              color: themes.green,
              border: '1px solid #4CAF50',
            }}
          >
            {trans('Return')}
          </Button>
        </Grid>
      ) : (
        <></>
      )}
    </Grid>
  );
};
export default ActiveAssetListBox;
